import getSupportedLocales from '../../site-locales/accessors/get-supported-locales';
import constants from '../../site-locales/constants';

const { HOME_PAGE_PATH_REGEXP } = constants.common;

const isHomePage = (path, languageCodes) => {
  if (path === '/') return true;

  let codes = languageCodes;

  if (!codes) {
    codes = getSupportedLocales();
  }

  if (codes.length && HOME_PAGE_PATH_REGEXP.test(path)) {
    const locale = path.match(HOME_PAGE_PATH_REGEXP)[1];
    return Boolean(locale) && codes.includes(locale);
  }

  return false;
};

export default isHomePage;
